import Vue from 'vue';

export const SET_BRANDS_FILTER = 'setBrandsFilter';
export const SET_BRANDS_DATA = 'setBrandsData';
export const UPDATE_BRAND_NOTES = 'updateBrandNotes';

export default {
  state: {
    filters: {
      search: '',
      owner: null,
    },
    brands: [],
    brandsById: {},
  },
  mutations: {
    [SET_BRANDS_FILTER](state, payload) {
      state.filters = {
        ...state.filters,
        ...payload,
      };
    },
    [SET_BRANDS_DATA](state, brands) {
      state.brands = brands;
      state.brandsById = brands.reduce((acc, brand) => {
        if (brand.id) {
          acc[brand.id] = brand;
        }
        return acc;
      }, {});
    },
    [UPDATE_BRAND_NOTES](state, { accountId, notes }) {
      const brandIndex = state.brands.findIndex(
        (brand) => brand.id === accountId,
      );
      if (brandIndex !== -1) {
        Vue.set(state.brands[brandIndex], 'notes', notes);
      }
      if (state.brandsById[accountId]) {
        Vue.set(state.brandsById[accountId], 'notes', notes);
      }
    },
  },
  getters: {
    getBrandByAccountId: (state) => (accountId) => {
      return state.brandsById[accountId] || null;
    },
  },
};
